import React from 'react';
import { Button } from '@mantine/core';
import { useAuth } from '../../auth/AuthProvider';
import classes from '../../pages/HomePage.module.css';

export const LoginButton: React.FC = () => {
  const { isAuthenticated, login, logout, user } = useAuth();

  return (
    <div>
      {isAuthenticated ? (
        <div>
          <span style={{ marginRight: '10px' }}>
            Welcome, {user?.name || user?.username || 'User'}
          </span>
          <Button onClick={logout} color="red">
            Sign Out
          </Button>
        </div>
      ) : (
        <Button 
          onClick={login} 
          radius="xl" 
          className={classes.gradientButton}
        >
          Sign In
        </Button>
      )}
    </div>
  );
}; 